import * as React from 'react'
import { Container, Dropdown, Icon, Image, Menu } from 'semantic-ui-react'
import './MenuResponsive.css'
import { Link } from 'react-router-dom'

type MenuProps = {
    fixed?: boolean,
    isLoggedIn: boolean,
    userInfo?: IUser,
    handleSignIn: (event: React.MouseEvent<any>) => void,
    handleSignOut: (event: React.MouseEvent<any>) => void,
    handleRegister: (event: React.MouseEvent<any>) => void,
}

const menuAdmin = (
    <Menu.Menu position={'right'}>
        <Menu.Item>
            <div className="menuFix">
                <div className="labelMenu"><Icon circular={true} name="setting"/><Link to="/admin">Admin</Link></div>
            </div>
        </Menu.Item>
    </Menu.Menu>
)

export const MenuReponsive: React.SFC<MenuProps> = (props) => {
    const {handleSignIn, handleRegister, isLoggedIn, handleSignOut, userInfo, fixed} = props
    let username
    let amount
    let totalDep

    if (userInfo) {
        username = userInfo.username
        amount = userInfo.amount
        totalDep = userInfo.totalDep
    }
    const userMenuInfo = `${username}`

    const menuUser = (
        <Menu.Menu position={'left'}>
            <Menu.Item className="menuDropDown">
                <Dropdown pointing="top left" item={true} text={userMenuInfo}>
                    <Dropdown.Menu>
                        <Dropdown.Item disabled={true}>
                            Tài khoản: ${amount ? amount.toLocaleString('vn') : '0'}đ
                        </Dropdown.Item>
                        <Dropdown.Item disabled={true}>
                            Tiền đổi thưởng: ${totalDep ? totalDep.toLocaleString('vn') : '0'}đ
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to={'/user/info'}>Chỉnh sửa thông tin</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
            <Menu.Item className="menuDropDown">
                <Dropdown pointing="top left" item={true} text="Nạp tiền">
                    <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={'/user/depositBank'}>Nạp tiền qua chuyển khoản</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>
        </Menu.Menu>
    )
    return (

        <div className="colorNavBar">

            <Menu
                fixed={fixed ? 'top' : undefined}
                inverted={!fixed}
                pointing={true}
                secondary={!fixed}
                size="huge"
                stackable={true}
                borderless={true}
            >
                <Container className="menu-container">
                    <Image
                        as={'a'}
                        href={'/pick'}
                        src={fixed ? '/img/ezlogofinal_invert.png' : '/img/ezlogofinal.png'}
                        size={'medium'}
                    />
                    {userInfo && userInfo.role === 'SUPER_ADMIN' && menuAdmin}
                    {userInfo && userInfo.role === 'REGULAR_USER' && menuUser}
                    <Menu.Item>
                        <div className="menuFix">
                            <div><Icon circular={true} name="gift"/>
                            <Link className="labelMenu" to="/pick">Roll Gift</Link>
                            </div>
                        </div>
                    </Menu.Item>
                    <Menu.Item>
                        <div className="menuFix">
                            <div>
                                <Icon circular={true} name="cart"/>
                                <Link className="labelMenu" to="/exchange-coin">Item try hard Dota/CSGO</Link>
                            </div>
                        </div>
                    </Menu.Item>
                    <Menu.Item>
                        <div className="menuFix">
                            <div>
                                <Icon circular={true} name="dollar"/>
                                <Link
                                  className="labelMenu"
                                  // to={{ pathname: 'https://csgoempire.vn' }}
                                  // target="_blank"
                                  to={'/tip'}
                                >
                                    Coin CSGOEmpire
                                </Link>
                            </div>
                        </div>
                    </Menu.Item>
                    {(isLoggedIn) &&
                    <Menu.Menu position="right">
                        <Menu.Item onClick={handleSignOut} header={true}>
                            <Icon circular={true} name="sign out"/>Đăng xuất
                        </Menu.Item>
                    </Menu.Menu>}
                    {(!isLoggedIn) &&
                    <Menu.Menu position="right" stackable={true}>
                        <Menu.Item onClick={handleSignIn} header={true}>
                            <Icon circular={true} name="sign in"/>Đăng nhập
                        </Menu.Item>
                        <Menu.Item onClick={handleRegister} header={true}>
                            <Icon circular={true} name="signup"/>Đăng ký
                        </Menu.Item>
                    </Menu.Menu>}
                </Container>
            </Menu>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/components/MenuResponsive.tsx